<template>
  <b-card>
    <b-card-text>
      <div class="d-flex justify-content-between align-items-center">
        <h4><feather-icon icon="HelpCircleIcon" size="20" /> إرشادات</h4>
        <feather-icon
          class="cursor-pointer text-info"
          icon="VideoIcon"
          size="22"
          @click="videoModal = true"
          v-if="docs && docs.video"
        />
      </div>
      <hr />
      <div
        style="text-align: justify"
        v-if="docs && docs.content"
        v-html="docs.content"
      ></div>
      <span v-else class="text-muted mt-1">
        ستتوفر إرشادات هذه الصفحة قريباً ...
      </span>
    </b-card-text>
    <b-modal
      v-if="docs && docs.video"
      title="فيديو تعليمي"
      size="lg"
      v-model="videoModal"
      footer-class="removed"
    >
      <video width="100%" alt="" controls>
        <source :src="docs.video" type="video/mp4" />
        <source :src="docs.video" type="video/ogg" />
      </video>
    </b-modal>
  </b-card>
</template>

<script>
import { BCard, BModal, BCardText } from "bootstrap-vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  components: {
    BCard,
    BModal,
    BCardText,
  },
  props: {
    slug: String,
  },
  data() {
    return {
      videoModal: false,
    };
  },
  computed: {
    ...mapGetters("NgoProfile", ["docs"]),
    parsedSlug() {
      return this.slug || this.$route.meta.instructionsSlug;
    },
  },
  methods: {
    ...mapActions("NgoProfile", ["fetchDocs"]),
    ...mapMutations("NgoProfile", ["setDocs"]),
  },
  mounted() {
    if (this.slug) this.fetchDocs(this.slug);
    else if (this.$route.meta.instructionsSlug)
      this.fetchDocs(this.$route.meta.instructionsSlug);
  },
  watch: {
    "$route.meta.instructionsSlug"(val) {
      this.setDocs({});
      if (val) this.fetchDocs(this.parsedSlug);
    },
    slug(val) {
      this.setDocs({});
      if (val) this.fetchDocs(this.parsedSlug);
    },
  },
};
</script>
